import { useState } from 'react';
import { eyebrowStyle, h2Style, subtitleStyle, primaryBtnStyle } from './tokens';
import { reportQuestion, humanizeError } from '../../lib/communityService';

const REASONS = [
  { key: 'spam',            label: 'Spam or advertising' },
  { key: 'misinformation',  label: 'Medical misinformation' },
  { key: 'harassment',      label: 'Harassment or hate' },
  { key: 'other',           label: 'Something else' },
];

/**
 * ReportModal — collects a reason and sends to community_reports.
 */
export default function ReportModal({ userId, questionId, onClose }) {
  const [reason, setReason] = useState(null);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    if (!reason || !userId) return;
    setSending(true);
    setError(null);
    const res = await reportQuestion({ userId, questionId, reason });
    setSending(false);
    if (res.error) { setError(humanizeError(res.error)); return; }
    setDone(true);
  };

  return (
    <div
      onClick={onClose}
      data-testid="report-modal"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(14,15,19,.45)', zIndex: 9998,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 440, background: '#fff', borderRadius: 20,
          padding: '22px 20px 24px', boxShadow: '0 24px 60px rgba(0,0,0,.28)',
        }}
      >
        {done ? (
          <div style={{ textAlign: 'center' }} data-testid="report-done">
            <div style={{ fontSize: 40, marginBottom: 8 }}>✓</div>
            <h2 style={h2Style}>Thank you.</h2>
            <p style={subtitleStyle}>Our team will review this shortly.</p>
            <button onClick={onClose} style={primaryBtnStyle} data-testid="report-close">Close</button>
          </div>
        ) : (
          <>
            <div style={eyebrowStyle}>REPORT THIS QUESTION</div>
            <h2 style={h2Style}>What went wrong?</h2>
            <p style={{ ...subtitleStyle, marginBottom: 16 }}>Choose a reason so the team can review it faster.</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
              {REASONS.map((r) => {
                const on = reason === r.key;
                return (
                  <button
                    key={r.key}
                    onClick={() => setReason(r.key)}
                    data-testid={`report-reason-${r.key}`}
                    style={{
                      textAlign: 'left', padding: '12px 14px', borderRadius: 12, cursor: 'pointer',
                      background: on ? 'rgba(109,94,245,.10)' : '#FFFFFF',
                      border: on ? '1px solid rgba(109,94,245,.30)' : '1px solid rgba(0,0,0,.08)',
                      color: '#232323', fontSize: 13.5, fontWeight: on ? 600 : 500,
                      fontFamily: 'inherit',
                    }}
                  >
                    {on ? '● ' : '○ '}{r.label}
                  </button>
                );
              })}
            </div>

            <button
              onClick={submit}
              disabled={!reason || sending}
              data-testid="report-submit"
              style={{ ...primaryBtnStyle, opacity: (!reason || sending) ? 0.4 : 1, cursor: (!reason || sending) ? 'not-allowed' : 'pointer' }}
            >
              {sending ? 'Sending…' : 'Submit report'}
            </button>
            <button
              onClick={onClose}
              disabled={sending}
              data-testid="report-cancel"
              style={{
                width: '100%', marginTop: 10, padding: 12, borderRadius: 999,
                background: 'transparent', border: 'none', color: '#6D5EF5',
                fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              Cancel
            </button>
            {error && (
              <div data-testid="report-error" style={{ fontSize: 12, color: '#C67A69', textAlign: 'center', marginTop: 10 }}>
                {error}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
